export const environment = {
  production: false,
  version: '0.15',
  firebaseProject: 'hubbleai-frontend-dev',
  apiBaseUrl: 'https://dev-api.hubbleapp.ai',
  firebaseConfig: {
    apiKey: "AIzaSyDhpFaTQqcL3sB0uV8r_FIGS5prahJ9JZw",
    authDomain: "hubbleai-frontend-dev.firebaseapp.com",
    projectId: "hubbleai-frontend-dev",
    storageBucket: "hubbleai-frontend-dev.firebasestorage.app",
    messagingSenderId: "662057702481",
    appId: "1:662057702481:web:29ebb21b3dcebb17089470",
    measurementId: "G-45PXRQDKWR"
  }
};